import React, { useState, useContext, useMemo, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledModalCicloAdd } from "../../styled-components/StyledModalCicloAdd.style";
import Swal from "sweetalert2";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DynamicInput } from "../DynamicInput";
import api from '../../services/api';
import IntlCurrencyInput from "react-intl-currency-input"
import { StldInput } from '../../styled-components/StyledInput.style';
import { ToggleSwitch } from "../ToggleSwitch";
import { DynamicSelectPME } from "../DynamicSelectPME";
import { DynamicInputPME } from "../DynamicInputPME";
import { get } from "react-hook-form";

const MemorizedDynamicInput = React.memo(DynamicInputPME)

export const ModalRegrasMeritoPme = ({ isOpen, onAfterOpen, onRequestClose, idProgramaParam, meritoEdit, idRegraMerito, listArea, listMeritos, loadPage }) => {
    const [isLoading, setisLoading] = useState(false);
    const formDataInicial = {
        idRegraMerito: 0,
        idArea: 0,
        isDefault: false,
        valorHFMI: '',
        valorHMFU: '',
        valorHMFG: ''
    };
    
    const [formData, setFormData] = useState(formDataInicial);

    const getRegraMerito = async (idRegraMerito) => {
        const meritos = await api.get(`PmeRegra/merito/edit/${idRegraMerito}`);
        return meritos.data;
    };

    useEffect(() => {
        const carregarRegraMerito = async () => {
            if (meritoEdit && idRegraMerito) {
                try {
                    const { data } = await api.get(`PmeRegra/merito/edit/${idRegraMerito}`);
                    setFormData({
                        idRegraMerito: data.idRegrasMerito,
                        idArea: data.idArea,
                        isDefault: data.isDefault,
                        valorHFMI: data.valorHFMI,
                        valorHMFU: data.valorHMFU,
                        valorHMFG: data.valorHMFG
                    });
                } catch (error) {
                    console.error("Erro ao buscar regra de mérito:", error);
                }
            }
        };
    
        carregarRegraMerito();
    }, [isOpen, meritoEdit, idRegraMerito]);

    const style = {
        content: {
            top: '45%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '50%',
            overflowY: 'auto',
            minHeight: 'calc(0vh - 250px)',
            maxHeight: 'calc(100vh - 250px)',
        },
        overlay: {
            zIndex: 9999
        }
    };

    const handleChangeArea = (_, area) => {
        setFormData(prev => ({ ...prev, idArea: parseInt(area) || null }));
    };
      

    const handleToggleChangeDefault = (status) => {
        setFormData(prev => ({ ...prev, isDefault: status }));
    };

    const handleInputChange = (name) => (value) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };

    const saveRegraMerito = async () => {        
        let campos = [];
        if (!formData.isDefault && formData.idArea <= 0) campos.push("Se não selecionar uma área, o padrão deve ser marcado.");

        if (formData.isDefault && formData.idArea > 0) campos.push("Não pode selecionar uma área com padrão marcado.");

        if (campos.length > 0) {
            const camposFaltantes = campos.join(', ');
            registrationFailure(`Verifique os campos obrigatórios: ${camposFaltantes}`);
            return;
        }

        var payload = {
            idPrograma: parseInt(idProgramaParam),
            idArea: formData.idArea,
            isDefault: formData.isDefault,
            valorHFMI: parseFloat(formData.valorHFMI) ?? 0,
            valorHMFU: parseFloat(formData.valorHMFU) ?? 0,
            valorHMFG: parseFloat(formData.valorHMFG) ?? 0,
        };
        
        try {
            if (meritoEdit) {
                await api.put(`PmeRegra/merito/atualizar/${formData.idRegraMerito}`, payload);
            } else {
                await api.post('PmeRegra/merito/nova', payload);
            }

            Swal.fire({
                title: "Sucesso",
                text: "Cadastro realizado com sucesso",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
            });
            setFormData(formDataInicial);
            onRequestClose();

          // Aqui você já pode enviar via API
        } catch (error) {
            console.log(error);

            const msg = error?.response?.data?.mensagem || "Erro ao salvar regra.";
        
            Swal.fire({
                title: "Erro",
                text: msg,
                icon: "error",
                confirmButtonText: "OK"
            });
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="PME - Regras de Mérito"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledModalCicloAdd>
                <StyledForm>
                    <p className="modal-close" onClick={onRequestClose}>X</p>
                </StyledForm>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Adicionar Nova Regra de Mérito</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    {isLoading ? (
                        <div className="text-center">
                            <div className="align-items-center">
                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className='row justify-align-content-around mt-3'>
                                <div className="position-relative form-group col-sm-4 col-md-4 col-lg-4">
                                    <DynamicSelectPME
                                        placeholder=""
                                        valuetext={formData.idArea}
                                        label="Selecione uma Área"
                                        name="idArea"
                                        options={listArea}
                                        keyValue="idArea"
                                        keyLabel="description"
                                        paramMethod={handleChangeArea}
                                        clearOption={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-2 col-md-2 col-lg-2">
                                    <ToggleSwitch 
                                        config={{ name: 'isDefault', label: 'Padrão', status: formData.isDefault }}
                                        setStatus={handleToggleChangeDefault} />
                                </div>
                            </div>
                            <div className='row justify-align-content-around mt-3'>
                                <div className="position-relative form-group col-sm-4 col-md-4 col-lg-4">
                                    <MemorizedDynamicInput
                                        mask="9999.99"
                                        placeholder=''
                                        label='% HFMI'
                                        name='valorHFMI'
                                        value={formData.valorHFMI}
                                        paramMethod={handleInputChange('valorHFMI')} />
                                </div>
                                <div className="position-relative form-group col-sm-4 col-md-4 col-lg-4">
                                    <MemorizedDynamicInput
                                        mask="9999.99"
                                        placeholder=''
                                        label='% HMFU'
                                        name='valorHMFU'
                                        value={formData.valorHMFU}
                                        paramMethod={handleInputChange('valorHMFU')} />
                                </div>
                                <div className="position-relative form-group col-sm-4 col-md-4 col-lg-4">
                                    <MemorizedDynamicInput
                                        mask="9999.99"
                                        placeholder=''
                                        label='% HMFG'
                                        name='valorHMFG'
                                        value={formData.valorHMFG}
                                        paramMethod={handleInputChange('valorHMFG')} />
                                </div>
                            </div>
                            <div className='d-flex justify-content-left m-0 p-0'>
                                <button type="button" className='default-button-red-small' onClick={() => saveRegraMerito()}>Salvar Regra</button>
                            </div>
                        </div>
                    )}
                </StyledForm>
            </StyledModalCicloAdd>
        </Modal>
    );
};